export const getCookieValue = (cookieKey) => {
    if (document.cookie) {
        const valueInfo = document.cookie.match(new RegExp('(^| )' + cookieKey + '=([^;]+)'));
        if (valueInfo && valueInfo.length > 2) {
            return valueInfo[2];
        }        
    }
    
    return null;
}